// The Cloudish logo: the mark (brand/marks.tsx, the trajectory around four
// stars with its two comets) beside the "Cloudish" wordmark. Used by the
// site header, footer, dashboard sidebar, and the outage page.
//
// `height` is the wordmark's line height, as before; the mark is sized to
// sit beside it at 1.6× that width (35 px in the 22 px header), cropped
// tight to its own ink so it isn't padded out like the square favicon.
//
// The mark is its own file (public/cloudish-mark.svg, MarkArt exported by
// scripts/export-brand.mjs), not inline: drawn with every segment of its
// comet trails it's ~38 KB, and inline it would be sent twice (header and
// footer) with every page — to agents and crawlers too, who never need it.
// As a file it's fetched once and cached. Same pixels: the dark theme's
// filter applies to the image just as it did to the inline SVG.

import { markHeight } from '../brand/marks';

export function Logo({ height = 22, className = '' }: { height?: number; className?: string }) {
  const width = Math.round(height * 1.6);
  return (
    <span className={`logo-mark ${className}`} role="img" aria-label="Cloudish" style={{ height, display: 'inline-flex', alignItems: 'center' }}>
      <img src="/cloudish-mark.svg" width={width} height={Number(markHeight(width).toFixed(2))} alt="" aria-hidden="true" decoding="async" />
      <span className="logo-wordmark">Cloudish</span>
    </span>
  );
}

export default Logo;
